import {
  CodeBlock,
  DateDisplay,
  getSideDrawerContentStyles,
  InfoDrawerMeta,
  SideDrawer,
} from "@inductiveautomation/ws-components";
import { useTranslation } from "react-i18next";
import { LicenseSession } from "../../Licenses.types";

const ActivationsDrawer = ({
  session,
  onClose,
}: {
  session: LicenseSession | undefined;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const { classes: drawerClasses } = getSideDrawerContentStyles();

  return (
    <SideDrawer
      testId="license-activation-side-drawer"
      open={!!session}
      onClose={onClose}
      variant="modal"
      hideBackdrop
      contentSpacing="fullWidth"
      headerProps={{
        overline: t("maker_license.tabs.activations.drawer.overline"),
        heading: session?.name ?? "",
        icon: "session",
        avatarProps: {
          iconAvatarColor: "primary",
        },
        showCloseButton: true,
      }}
    >
      <InfoDrawerMeta
        heading={t("maker_license.tabs.activations.drawer.details.heading")}
        fields={[
          {
            label: t(
              "maker_license.tabs.activations.drawer.details.ip_address"
            ),
            value: session?.ipAddress ?? "-",
          },
          {
            label: t("maker_license.tabs.activations.drawer.details.date"),
            value: <DateDisplay date={session?.validated} />,
          },
          {
            label: t("maker_license.tabs.activations.drawer.details.response"),
            value: "[Activation-Response]",
          },
        ]}
      />
      <CodeBlock
        overline={t("maker_license.tabs.activations.drawer.advanced_details")}
        language={t("common.code_block.json")}
        className={drawerClasses.contentSectionContainer}
        code={`{
  "key": "value",
  "key": "value",
  "key": "value"
}`}
      />
    </SideDrawer>
  );
};

export default ActivationsDrawer;
